import Track from '../../utils/tracking';
import {selectDeliveryAddress} from '../address-actions';
import * as CheckoutAPIActions from '../APIActions/CheckoutAPIActions';
import {getDeliveryOptions, resetDeliveryOptions} from '../deliveryOptionActions';
import {getOrderSummaryForCountry} from '../orderSummaryActions';

export default (addressId, selectedAddressCategory, country) => (dispatch) => {
  dispatch(selectDeliveryAddress(addressId));
  
  dispatch(CheckoutAPIActions.setSelectedAddress({selectedAddressId: addressId, selectedAddressCategory})).then(() => {
    if (!addressId) {
      dispatch(resetDeliveryOptions());
      dispatch(getDeliveryOptions());
      dispatch(getOrderSummaryForCountry({value: country}));
    } else {
      dispatch(getDeliveryOptions());
    }
  }).catch((err) => {
    Track.error(`Failed to set selected address ID and category with error: ${err}`);
  });
};
